export const getDoSpacesUrl = (key: string) => `https://szrch-prod.nyc3.digitaloceanspaces.com/${key}`;
